import { faAngleLeft } from '@fortawesome/pro-light-svg-icons'
import { Button, Flex, Form, Spacer } from '@pinchenterprisesnpm/friday-ui'
import { Formik } from 'formik'
import ForgotPasswordLogo from 'img/logo-forgot-password.png'
import { API } from 'network'
import { NotificationManager } from 'helpers/NotificationsManager'
import { handleErrorNotification } from 'services/ErrorHandlingService'
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome'
import { OuterWrapper } from '../LoginForm/style'
import { TLoginChildrenProps } from '..'
import {
  TForgotPasswordValues,
  initialForgotPasswordValues,
  forgotPasswordValidationSchema,
} from './utils'
import {
  Description,
  FieldLabel,
  ForgotPasswordWrapper,
  Heading,
  BackToLoginLabel,
  LogoImg,
} from './style'

const { Input } = Form

const ForgotPasswordForm = ({ handleSwitchScreen }: TLoginChildrenProps) => {
  return (
    <OuterWrapper>
      <ForgotPasswordWrapper>
        <Flex alignItems='center' justifyContent='center'>
          <LogoImg src={ForgotPasswordLogo} />
        </Flex>
        <Spacer space='md' />
        <Formik
          initialValues={initialForgotPasswordValues}
          onSubmit={async ({ email }: TForgotPasswordValues, { setSubmitting }) => {
            try {
              await API.Password.forgotPassword({
                email,
              })
              NotificationManager.success('Check your email for reset link!')
              handleSwitchScreen()
            } catch (e) {
              handleErrorNotification(e)
            } finally {
              setSubmitting(false)
            }
          }}
          validationSchema={forgotPasswordValidationSchema}
        >
          {(formikProps) => {
            const {
              errors,
              handleChange,
              handleBlur,
              values,
              handleSubmit,
              touched,
              isSubmitting,
            } = formikProps
            return (
              <Form onSubmit={handleSubmit}>
                <Heading>Forgot Password</Heading>
                <Description>
                  To reset your password, please enter your email below. We will send you further
                  instructions on your email address.
                </Description>
                <div>
                  <FieldLabel>Email</FieldLabel>
                  <Spacer space='xs' />
                  <Input
                    name='email'
                    value={values.email}
                    placeholder='Your email'
                    onChange={handleChange}
                    onBlur={handleBlur}
                    errorMessage={errors.email && touched.email ? errors.email : undefined}
                  />
                </div>
                <Spacer space='xl' />
                <Flex justifyContent='space-between' alignItems='center'>
                  <BackToLoginLabel onClick={handleSwitchScreen}>
                    <FontAwesomeIcon icon={faAngleLeft} /> Back to Login
                  </BackToLoginLabel>
                  <Button htmlType='submit' isDisabled={isSubmitting} isLoading={isSubmitting}>
                    Reset
                  </Button>
                </Flex>
              </Form>
            )
          }}
        </Formik>
      </ForgotPasswordWrapper>
    </OuterWrapper>
  )
}

export default ForgotPasswordForm
